import React from "react"
import { Theme } from "@mui/material/styles"
import theme from "lib/material-ui/theme"
import { CLOSE_FRIENDS, CREATE_ITEM, EDIT_ITEM, PRIVATE, PROTECTED, PUBLIC } from "constants/index"
import {
  HANDLE_ADD_ITEM_TO_LIST,
  HANDLE_DELETE_ITEM,
  HANDLE_DELETE_LIST,
  HANDLE_EDIT_ITEM,
  HANDLE_EDIT_LIST,
  HANDLE_COPY_ITEM_LINK,
  HANDLE_COPY_LIST_LINK,
  HANDLE_TRANSFER_ITEM_TO_OTHER_LISTS
} from "constants/events"
import PublicIcon from "components/atoms/_icons/PublicIcon"
import ProtectedIcon from "components/atoms/_icons/ProtectedIcon"
import CloseFriendIcon from "components/atoms/_icons/CloseFriendIcon"
import PrivateIcon from "components/atoms/_icons/PrivateIcon"
import { BottomSheetAction } from "types/general.types"
import TransferIcon from "components/atoms/_icons/TransferIcon"
import LinkIcon from "components/atoms/_icons/LinkIcon"
import EditIcon from "components/atoms/_icons/EditIcon"
import TrashIcon from "components/atoms/_icons/TrashIcon"
import AddSquareIcon from "components/atoms/_icons/AddSquareIcon"

export type PrivacyOption = {
  key: Privacy;
  label: string;
  icon: React.ReactNode;
  filledIcon: React.ReactNode;
  palette: "info" | "success" | "warning" | "primary"
  getColor: (theme: Theme) => string | undefined;
}

export const privacyOptions: PrivacyOption[] = [
  {
    key: PUBLIC,
    label: "collections.public",
    icon: <PublicIcon/>,
    filledIcon: <PublicIcon variant={"filled"}/>,
    palette: "info",
    getColor: (theme: Theme) => theme.palette.info["4"]
  },
  {
    key: PROTECTED,
    label: "collections.protected",
    icon: <ProtectedIcon/>,
    filledIcon: <ProtectedIcon variant={"filled"}/>,
    palette: "primary",
    getColor: (theme: Theme) => theme.palette.primary["5"]
  },
  {
    key: CLOSE_FRIENDS,
    label: "collections.closeFriends",
    icon: <CloseFriendIcon strokeWidth={1.5} stroke={theme.palette.gray["11"]} fill={"transparent"}/>,
    filledIcon: <CloseFriendIcon strokeWidth={1.5} stroke={theme.palette.success["4"]} fill={theme.palette.success["4"]}/>,
    palette: "success",
    getColor: (theme: Theme) => theme.palette.success["4"]
  },
  {
    key: PRIVATE,
    label: "collections.private",
    icon: <PrivateIcon/>,
    filledIcon: <PrivateIcon variant={"filled"}/>,
    palette: "warning",
    getColor: (theme: Theme) => theme.palette.warning["4"]
  }
]

export const wishListActions = [
  {
    key: "add",
    premiumPermissionKey: CREATE_ITEM,
    icon: <AddSquareIcon/>,
    eventName: HANDLE_ADD_ITEM_TO_LIST,
    labelKey: "items.addItem"
  },
  {
    key: "share",
    icon: <LinkIcon/>,
    eventName: HANDLE_COPY_LIST_LINK,
    labelKey: "general.copyLink"
  },
  {
    key: "edit",
    icon: <EditIcon/>,
    eventName: HANDLE_EDIT_LIST,
    labelKey: "general.edit"
  },
  {
    key: "delete",
    icon: <TrashIcon/>,
    eventName: HANDLE_DELETE_LIST,
    labelKey: "general.delete",
    getColor: (theme: Theme) => theme.palette.error["4"]
  }
]

export const wishItemActions: BottomSheetAction[] = [
  {
    key: "transfer",
    icon: <TransferIcon/>,
    eventName: HANDLE_TRANSFER_ITEM_TO_OTHER_LISTS,
    labelKey: "items.transferToOtherLists"
  },
  {
    key: "share",
    icon: <LinkIcon/>,
    eventName: HANDLE_COPY_ITEM_LINK,
    labelKey: "general.copyLink"
  },
  {
    key: "edit",
    premiumPermissionKey: EDIT_ITEM,
    icon: <EditIcon/>,
    eventName: HANDLE_EDIT_ITEM,
    labelKey: "general.edit"
  },
  {
    key: "delete",
    icon: <TrashIcon/>,
    eventName: HANDLE_DELETE_ITEM,
    labelKey: "general.delete",
    getColor: (theme: Theme) => theme.palette.error["4"]
  }
]
